<template>
  <div>
    <div class="app-schedule">
      <div class="app-schedule__filters">
        <!-- <div class="app-schedule__head"> -->
        <div class="app-schedule__slider">
          <div class="app-schedule__slider-prev">
            <svg
              @click="prevMonth"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.31396 10.7859L12.2778 16.0404C12.66 16.4451 13.3039 16.4451 13.6862 16.0404C14.0386 15.6673 14.039 15.0841 13.6869 14.7107L9.98738 10.7859L13.6869 6.8611C14.039 6.48764 14.0386 5.90444 13.6862 5.53136C13.3039 5.12669 12.66 5.12669 12.2778 5.53136L7.31396 10.7859Z"
                fill="var(--menu-text-color)"
              />
              <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="7"
                y="5"
                width="7"
                height="12"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.31396 10.7859L12.2778 16.0404C12.66 16.4451 13.3039 16.4451 13.6862 16.0404C14.0386 15.6673 14.039 15.0841 13.6869 14.7107L9.98738 10.7859L13.6869 6.8611C14.039 6.48764 14.0386 5.90444 13.6862 5.53136C13.3039 5.12669 12.66 5.12669 12.2778 5.53136L7.31396 10.7859Z"
                  fill="var(--menu-text-color)"
                />
              </mask>
              <g mask="url(#mask0)" />
            </svg>
          </div>
          <div class="app-schedule__slider-month">
            {{ getMonthName(params.month) }}
          </div>
          <div class="app-schedule__slider-next">
            <svg
              @click="nextMonth"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.6162 10.5161L9.65242 5.26152C9.27014 4.85685 8.62625 4.85685 8.24397 5.26152C7.89154 5.6346 7.89122 6.2178 8.24325 6.59127L11.9428 10.5161L8.24325 14.4408C7.89122 14.8143 7.89154 15.3975 8.24397 15.7706C8.62625 16.1753 9.27014 16.1753 9.65242 15.7706L14.6162 10.5161Z"
                fill="var(--menu-text-color)"
              />
              <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="7"
                y="4"
                width="8"
                height="13"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.6162 10.5161L9.65242 5.26152C9.27014 4.85685 8.62625 4.85685 8.24397 5.26152C7.89154 5.6346 7.89122 6.2178 8.24325 6.59127L11.9428 10.5161L8.24325 14.4408C7.89122 14.8143 7.89154 15.3975 8.24397 15.7706C8.62625 16.1753 9.27014 16.1753 9.65242 15.7706L14.6162 10.5161Z"
                  fill="var(--menu-text-color)"
                />
              </mask>
              <g mask="url(#mask0)" />
            </svg>
          </div>
        </div>
        <!-- </div> -->

        <Select2
          :settings="{
            placeholder: $t('forms.master'),
            allowClear: false,
          }"
          :options="mastersToSelect"
          @select="changeMaster($event)"
          class="mr-12"
          v-model="scheduleMasterId"
        />

        <Select2
          class="mr-12 select2-container_w148"
          :options="years"
          v-model="params.year"
          @select="changeSchedule"
        />

        <div class="app-schedule__actions">
          <button
            v-if="$guard('write', 'Masters')"
            @click="openClientScheduleModal"
            class="main-button main-button_foz14 main-button_w98 mr-12"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              id="Capa_1"
              x="0px"
              y="0px"
              viewBox="0 0 42 42"
              xml:space="preserve"
              width="20px"
              height="20px"
              class="mr-6"
            >
              <polygon
                points="42,19 23,19 23,0 19,0 19,19 0,19 0,23 19,23 19,42 23,42 23,23 42,23 "
                fill="#000"
              />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
              <g />
            </svg>
            Hinzufügen
          </button>
          <button
            v-if="$guard('write', 'Masters')"
            class="main-button main-button_foz14 main-button_w98 main-button_cancel"
            @click="deleteScheduleRequestAll"
          >
            Löschen
          </button>
        </div>
      </div>

      <div class="app-schedule__item">
        <div class="app-schedule__item-date"></div>
        <div class="app-schedule__item-view">
          <div class="schedule-row schedule-row_head">
            <div class="schedule-row__head">
              <div
                class="schedule-row__hour"
                v-for="(hour, index) in hours"
                :key="index"
              >
                {{ hour }}
              </div>
            </div>
          </div>
        </div>
        <div class="app-schedule__item-actions"></div>
      </div>

      <div class="app-schedule__list app-schedule__list_h84">
        <div
          class="app-schedule__item app-schedule__item_main"
          v-for="(item, day) in list"
          :key="day"
        >
          <div class="app-schedule__item-date">
            <p>
              {{ day }} /
              <span>{{ getWeekDay(day) }}</span>
            </p>
          </div>
          <div class="app-schedule__item-view">
            <div class="schedule-row">
              <div
                class="schedule-row__body schedule-row__body_pointer"
                @click="openEditScheduleModal(item, day)"
              >
                <div
                  class="schedule-row__hour"
                  v-for="(hour, index) in hours"
                  :key="index"
                ></div>

                <template v-if="item.schedule && item.schedule.from">
                  <div
                    class="schedule-row__time"
                    :style="{
                      left: getScheduleOffset(item.schedule),
                      width: getScheduleWidth(item.schedule),
                      backgroundColor: '#9BCD82',
                    }"
                    :key="`${day}_${item.schedule.from}${item.schedule.to}`"
                  ></div>
                </template>
              </div>
            </div>
          </div>
          <div class="app-schedule__item-actions app-schedule__item-actions_p">
            <svg
              v-if="
                item.schedule &&
                  item.schedule.from &&
                  $guard('write', 'Masters')
              "
              class="main-layout__item-icon"
              @click="deleteScheduleRequest(item.schedule.id)"
            >
              <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <modal
      :show="isOpenedClientScheduleModal"
      :dark="true"
      :outside="false"
      @close="toggleScheduleModal"
    >
      <schedule-view-modal @close="toggleScheduleModal" @done="done" />
      <!-- <schedule-modal :serviceId="serviceId" @close="toggleScheduleModal" /> -->
    </modal>

    <modal
      :show="isOpenedEditModalWindow"
      :dark="true"
      :outside="false"
      @close="closeEditScheduleModal"
    >
      <edit-schedule-modal
        @close="closeEditScheduleModal"
        @save="updateMasterSchedule"
      />
    </modal>

    <modal
      :show="isDeleteScheduleModal"
      :showBtn="false"
      :dark="true"
      :outside="false"
      @close="closeDeleteScheduleModal"
    >
      <delete-modal
        :title="$t('services.deleteTitle')"
        :cancelDeletionTag="servicesDeletionStatus"
        @cancel="closeDeleteScheduleModal"
        @next="deleteScheduleModal"
      />
    </modal>

    <modal
      :show="isDeleteScheduleModalAll"
      :showBtn="false"
      :dark="true"
      :outside="false"
      @close="closeDeleteScheduleModalAll"
    >
      <delete-modal
        :title="$t('services.deleteTitle')"
        :cancelDeletionTag="servicesDeletionStatus"
        @cancel="closeDeleteScheduleModalAll"
        @next="deleteScheduleModalAll"
      />
    </modal>
  </div>
</template>

<script>
import editScheduleModal from '@/components/modals/schedule/editMasterScheduleModal'
import moment from 'moment'
import scheduleViewModal from '@/components/modals/specialist/view/scheduleView'

import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    components: {
        editScheduleModal,
        scheduleViewModal,
    },
    data() {
        return {
            hours: [
                '00:00',
                '01:00',
                '02:00',
                '03:00',
                '04:00',
                '05:00',
                '06:00',
                '07:00',
                '08:00',
                '09:00',
                '10:00',
                '11:00',
                '12:00',
                '13:00',
                '14:00',
                '15:00',
                '16:00',
                '17:00',
                '18:00',
                '19:00',
                '20:00',
                '21:00',
                '22:00',
                '23:00',
            ],
            isDeleteScheduleModal: false,
            isDeleteScheduleModalAll: false,

            years: [2022, 2021, 2020],
            year: 2021,
            isOpenedscheduleModal: false,
            isOpenedEditModalWindow: false,
            mastersToSelect: [],
        }
    },
    watch: {
        year() {
            this.updateSchedule(this.serviceId)
        },
        serviceId(v) {
            this.updateSchedule(v)
        },
    },
    computed: {
        ...mapGetters({
            selectSettings: 'orders/selectSettingsGetters',
            services: 'servicesGettersWithAll',
            isOpenedClientScheduleModal: 'isOpenedClientScheduleModal',
            scheduleListByService: 'scheduleListByService',
            serviceId: 'scheduleServiceId',

            masters: 'specialists/getSpecialists',
            scheduleMasterId: 'specialists/scheduleMasterId',
            params: 'specialists/scheduleParams',
            list: 'specialists/scheduleList',
        }),
        serviceId: {
            get() {
                return this.$store.getters.scheduleServiceId
            },
            set(v) {
                this.setScheduleServiceId(v)
                return this.$store.getters.scheduleServiceId
            },
        },
        isClient() {
            return this.type === 'client'
        },
    },
    methods: {
        ...mapMutations({
            closeClientScheduleModal: 'closeClientScheduleModal',
            openClientScheduleModal: 'openClientScheduleModal',
            setClientScheduleParams: 'setClientScheduleParams',
            setClientScheduleParamsByService: 'setClientScheduleParamsByService',
            setScheduleServiceId: 'setScheduleServiceId',

            setState: 'specialists/setState',
            setScheduleDate: 'specialists/setScheduleDate',
            setScheduleMasterId: 'specialists/setScheduleMasterId',
            setEditSchedule: 'specialists/setEditSchedule',
            clearScheduleParams: 'specialists/clearScheduleParams',
        }),
        ...mapActions({
            getSpecialistSchedule: 'specialists/getSpecialistSchedule',
            updateScheduleById: 'specialists/updateScheduleById',
            addScheduleById: 'specialists/addScheduleById',
            deleteScheduleById: 'specialists/deleteScheduleById',
            deleteScheduleAll: 'specialists/deleteScheduleAll',
        }),
        getWeekDay(day) {
            return moment(day).format('ddd')
        },
        async updateMasterSchedule(data) {
            const isOkey = data.id
                ? await this.updateScheduleById(data)
                : await this.addScheduleById()

            if (!isOkey) return

            this.closeEditScheduleModal()
            this.changeSchedule()
        },
        done() {
            this.toggleScheduleModal()
            this.changeSchedule()
        },
        async changeSchedule() {
            await this.getSpecialistSchedule()
        },
        prevMonth() {
            if (this.params.month === 1) return
            this.params.month--

            this.getSpecialistSchedule()
        },
        nextMonth() {
            if (this.params.month === 12) return

            this.params.month++

            this.getSpecialistSchedule()
        },
        getMonthName(m) {
            return moment(moment().set('month', m - 1)).format('MMMM')
        },
        openEditScheduleModal(item, date) {
            if (!this.$guard('write', 'Masters')) return

            this.setEditSchedule({
                from: item.schedule.from || '09:00',
                to: item.schedule.to || '17:00',
                id: item.schedule.id || null,
                master_id: this.scheduleMasterId,
                date,
            })

            this.isOpenedEditModalWindow = true
        },
        closeEditScheduleModal() {
            this.isOpenedEditModalWindow = false
        },
        getBackgroundColor(index) {
            if (index === 1) return '#9BCD82'
            else if (index === 2) return '#F8CC1C'
            else if (index === 3) return '#D53E29'
        },
        getScheduleOffset(schedule) {
            const part = 100 / 24
            if (!schedule.from) return `${100 / 11}%`

            const scheduleStart = schedule.from.split(':')[0]

            return `${scheduleStart * part}%`
        },
        getScheduleWidth(schedule) {
            const part = 100 / 24

            const scheduleStartFrom = +schedule.from.split(':')[0]
            const scheduleStartTill = +schedule.to.split(':')[0]

            const parts = (scheduleStartTill - scheduleStartFrom) * part

            return `${parts}%`
        },
        async scheduleUpdated() {
            if (this.serviceId === 'all') {
                await this.fetchClientSchedule()
            } else {
                await this.fetchClientScheduleById()
            }

            this.isOpenedEditModalWindow = false
        },
        updateSchedule(type = 'default') {
            const params = {
                year: this.year,
                month: this.params.month,
            }

            if (type === 'default' || type === 'all') {
                this.setClientScheduleParams(params)
                this.fetchClientSchedule()
            } else {
                params.service_id = this.serviceId
                this.setClientScheduleParamsByService(params)
                this.fetchClientScheduleById()
            }
        },
        toggleScheduleModal() {
            this.closeClientScheduleModal()
        },
        deleteScheduleRequest(id) {
            this.deleteId = id
            this.isDeleteScheduleModal = true
        },
        deleteScheduleRequestAll() {
            this.isDeleteScheduleModalAll = true
        },
        closeDeleteScheduleModal() {
            this.isDeleteScheduleModal = false
        },
        closeDeleteScheduleModalAll() {
            this.isDeleteScheduleModalAll = false
        },
        async deleteScheduleModalAll() {
            // if (this.serviceId === "all") {
            //   await this.deleteClienScheduleAll({
            //     year: this.year,
            //     month: this.params.month,
            //   });

            //   this.isDeleteScheduleModalAll = false;
            //   this.fetchClientSchedule();
            // } else {
            //   await this.deleteClienScheduleAllByService({
            //     year: this.year,
            //     month: this.params.month,
            //     service_id: this.serviceId,
            //   });

            await this.deleteScheduleAll()
            this.isDeleteScheduleModalAll = false
            await this.changeSchedule()
            // this.fetchClientScheduleById();
            // }

            this.isDeleteScheduleModalAll = false
            await this.changeSchedule()
        },
        async deleteScheduleModal() {
            const isOkey = await this.deleteScheduleById(this.deleteId)

            if (!isOkey) return

            await this.changeSchedule()
            this.isDeleteScheduleModal = false
        },

        changeMaster({ id }) {
            this.setState({
                type: 'scheduleMasterId',
                data: id,
            })

            this.getSpecialistSchedule()
        },
        preparemastersToSelect() {
            if (this.mastersToSelect.length === 0) {
                return
            }

            if (this.mastersToSelect[0].id !== 'all') {
                this.mastersToSelect.unshift({
                    text: this.$t('listsHeader.all'),
                    id: 'all',
                })
            }
        },
        prepareMaster() {
            this.masters.forEach((e) => {
                this.mastersToSelect.push({
                    id: e.id,
                    text: `${e.first_name} ${e.last_name}`,
                })
            })
        },
    },
    mounted() {
        if (this.masters.length === 0) return
        this.prepareMaster()

        if (this.scheduleMasterId === null) {
            this.setState({
                type: 'scheduleMasterId',
                data: this.masters[0].id,
            })
        }
        // console.log(this.scheduleMasterId);
        this.getSpecialistSchedule()
    },
    beforeDestroy() {
        this.setScheduleServiceId('all')
        this.clearScheduleParams()
    },
}
</script>
